import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../ui/custom-table";
import { SetPopupReducerData } from "../../store/reducer/PopupReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  CameraTypeListingApi,
  DeleteCameraTypeListingApi,
} from "../../api/api";

function DeviceListing() {
  const dispatch = useDispatch();
  const [nvrData, setNvrData] = useState([]);
  //console.log("nvrData", nvrData);
  const [loading, setLoading] = useState(false);
  const { showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // Debounce by 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const fetchCamera = async () => {
    setLoading(true);
    try {
      const search = debouncedSearch;
      const data = await CameraTypeListingApi(search, user_id, organization_id);
      //console.log("data", data);
      if (data?.data?.status === true) {
        setNvrData(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCamera();
  }, [debouncedSearch]);

  useEffect(() => {
    if (showModal === false) {
      fetchCamera();
    }
  }, [showModal]);

  const columns = useMemo(
    () => [
      { accessorKey: "username", header: "Camera Name" },
      { accessorKey: "device_name", header: "Device Name" },
      {
        accessorKey: "camera_type.camera_type_name",
        header: "Camera Type",
        Cell: ({ row }) => row.original.camera_type?.camera_type_name || "-",
      },
      { accessorKey: "port", header: "Port No" },
      { accessorKey: "ip", header: "IP" },
    ],
    []
  );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADD_DEVICE",
        showModal: true,
      })
    );
  };

  const handleEdit = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADD_DEVICE",
        showModal: true,
        data: row._id,
      })
    );
  };

  const handleDelete = (row) => {
    DeleteCameraTypeListingApi(row?._id, user_id, organization_id);
    fetchCamera();
  };
  return (
    <>
      <aside className="mainSection">
        <CustomTable
          columns={columns}
          data={nvrData}
          loading={loading}
          onAddClick={handleAddClick}
          addButtonLabel="Add Device"
          onSearchChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          showActions={true}
          onDelete={handleDelete}
          onEdit={handleEdit}
        />
      </aside>
    </>
  );
}

export default DeviceListing;
